import { JobAlertConfigDetailsV2 } from './JobAlertConfigDetailsV2';
import { Filter } from '../jobs/filter';
import { notificationAlertTypes } from './notificationAlertTypes';

export class JobAlertV2 {
  public id: number = 0;
  public name: string = '';
  public email: string = '';
  public companyCode: string = '';
  public status: any = '';
  public jobAlertFrequency: string = '';
  public jobAlertConfigDetails: JobAlertConfigDetailsV2 = new JobAlertConfigDetailsV2();
  public notificationType:notificationAlertTypes = new notificationAlertTypes();
}
